// https://app.growthbook.io/features/pen-7233_v1
export const PROMO_BANNER_COUNTDOWN_FLAG_NAME = 'pen-7233_v1'
